<template>
  <div>
    <div class="row">
      <div class="col-12 mb-4" v-for="(item, index) in data" :key="index">
        <div class="card">
          <div class="card-header">
            {{ $t("message.business_score.vocabulary.year") }}: {{ item.year }}
          </div>
          <div class="card-body">
            <div class="row">
              <!-- Column 1 -->
              <div class="col-md-6">
                <p class="mb-2">
                  <strong>{{ $t("message.business_score.vocabulary.totalAsset") }}:</strong>
                  {{ item.totalAsset }}
                </p>
                <p class="mb-2">
                  <strong>{{ $t("message.business_score.vocabulary.totalEquity") }}:</strong>
                  {{ item.totalEquity }}
                </p>
                <p class="mb-2">
                  <strong>{{ $t("message.business_score.vocabulary.totalSale") }}:</strong>
                  {{ item.totalSale }}
                </p>
                <p class="mb-2">
                  <strong>{{ $t("message.business_score.vocabulary.primarySale") }}:</strong>
                  {{ item.primarySale }}
                </p>
                <p class="mb-2">
                  <strong>{{ $t("message.business_score.vocabulary.netProfits") }}:</strong>
                  {{ item.netProfits }}
                </p>
                <p class="mb-2">
                  <strong>{{ $t("message.business_score.vocabulary.tel") }}:</strong>
                  {{ item.tel }}
                </p>
              </div>
              <!-- Column 2 -->
              <div class="col-md-6">
                <p class="mb-2"><strong>{{ $t("message.business_score.vocabulary.totalProfits") }}:</strong>
                  {{ item.totalProfits }}
                </p>
                <p class="mb-2"><strong>{{ $t("message.business_score.vocabulary.totalTax") }}:</strong>
                  {{ item.totalTax }}
                </p>
                <p class="mb-2"><strong>{{ $t("message.business_score.vocabulary.totalLiability") }}:</strong>
                  {{ item.totalLiability }}
                </p>
                <p class="mb-2"><strong>{{ $t("message.business_score.vocabulary.postalcode") }}:</strong>
                  {{ item.postalcode }}
                </p>
                <p class="mb-2">
                  <strong>{{ $t("message.business_score.vocabulary.dom") }}:</strong>
                  {{ item.dom }}
                </p>
                <p class="mb-0">
                  <strong>{{ $t("message.business_score.vocabulary.email") }}:</strong>
                  {{ item.email }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    imLoaded: {
      type: Function,
      default: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.imLoaded) {
        this.imLoaded();
      }
    });
  },
};
</script>
